export default {
  baseUrl: 'https://ai-api.deepcity.cn/', // 正式服
  // baseUrl: 'http://localhost:8083/', // 本地环境
}